import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home.vue'
import Pricing from './views/Pricing.vue'
import BookDemo from './views/BookDemo.vue'
import BookDemoUploadDossierExamples from './views/BookDemoUploadDossierExamples.vue'
import Login from './views/Login.vue'
import Signup from './views/Signup.vue'
import ResetPasswordSendEmail from './views/ResetPasswordSendEmail.vue'
import ListDossiers from './views/ListDossiers.vue'
import CreateDossier from './views/CreateDossier.vue'
import EditProfileAsUser from './views/EditProfileAsUser.vue'
import OnboardingPersonalData from './views/OnboardingPersonalData.vue'
import OnboardingVerifyEmailAddressSendEmail from './views/OnboardingVerifyEmailAddressSendEmail.vue'
import VerifyEmailAddressSuccess from './views/VerifyEmailAddressSuccess.vue'
import OnboardingChooseCompany from './views/OnboardingChooseCompany.vue'
import Account from './views/Account.vue'
import Subscribe from './views/Subscribe.vue'
import SubscribeSuccess from './views/SubscribeSuccess.vue'
import EditSubscription from './views/EditSubscription.vue'
import Admin from './views/Admin.vue'
import ParentCompanyAdminDashboard from './views/ParentCompanyAdminDashboard.vue'
import Roadmap from './views/Roadmap.vue'

import store from './store'
import vuei18n from '@/i18n'

import ConsultantHome from './views/consultant/ConsultantHome.vue'
import ConsultantLogin from './views/consultant/ConsultantLogin.vue'
import ConsultantInvitationCode from './views/consultant/ConsultantInvitationCode.vue'
import ConsultantListDossiers from './views/consultant/ConsultantListDossiers.vue'
import ConsultantUploadCv from './views/consultant/ConsultantUploadCv.vue'
import EditProfileAsConsultant from './views/consultant/EditProfileAsConsultant.vue'

import EditProfileFromToken from './views/fromToken/EditProfileFromToken'
import EditProfileFromTokenSuccess from './views/fromToken/EditProfileFromTokenSuccess'
import FromTokenError from './views/fromToken/FromTokenError'
  
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter)


function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function waitForUserToBeLoaded() {
  const user = store.getters.user
  if (user.loggedIn === null) {
    await sleep(100);
    await waitForUserToBeLoaded()
  }
}

async function waitForCompanyToBeLoaded() {
  const user = store.getters.user
  if (!user.data || (user.data.companyId && user.company === null)) {
    await sleep(100);
    await waitForCompanyToBeLoaded()
  }
}

const checkIsNotLoggedIn = async (to, from, next) => {
  await waitForUserToBeLoaded()
  const user = store.getters.user
  if (user.loggedIn) {
    return next('/dossiers')
  } else {
    // Set Locale from query param ?lang=
    vuei18n.locale = to.query.lang
    return next()
  }
}


const redirectToAnOnboardingStepIfNeeded = (to, from, next) => {
  const user = store.getters.user

  const goToVerifyEmailAddress = !user.data.isEmailVerified
  if (goToVerifyEmailAddress) {
    if (to.path === '/onboarding/verify-email-success') return next()
    if (to.path !== '/onboarding/verify-email-address-send-email') return router.push('/onboarding/verify-email-address-send-email')
    else return next()
  } else {
    if (to.path === '/onboarding/verify-email-success') return next()
    if (to.path === '/onboarding/verify-email-address-send-email') return router.push('/dossiers').catch(error => console.info(error.message))
  }

  const goToOnboardingPersonalData = !user.data.firstName || !user.data.lastName
  if (goToOnboardingPersonalData) {
    if (to.path !== '/onboarding/personal-data' && from.path !== '/onboarding/personal-data') return router.push('/onboarding/personal-data')
    else return next()
  } else {
    if (to.path === '/onboarding/personal-data') return router.push('/dossiers').catch(error => console.info(error.message))
  }
  
  
  const goToOnboardingChooseCompany = !user.data.companyId
  if (goToOnboardingChooseCompany) {
    if (to.path !== '/onboarding/choose-company' && from.path !== '/onboarding/choose-company') return router.push('/onboarding/choose-company')
    else return next()
  } else {
    if (to.path === '/onboarding/choose-company') return router.push('/dossiers').catch(error => console.info(error.message))
  }
}




const redirectOutOfCreateDossierIfNoDossiersLeft = async (to, from, next) => {
  const user = store.getters.user
  if (to.path.startsWith('/dossiers/create')) {
    if (user.company.dossiersLeftNb > 0) {
      return next()
    } else {
      return next('/dossiers')
    }
  }
  return next()
}

const redirectOutOfSubscribePageIfAlreadyHasOrHadSubscription = async (to, from, next) => {
  const user = store.getters.user
  if (to.path === '/subscribe') {
    if (user.company.parentCompanyId) return next('/dossiers')
    if (user.company.hasOrHadSubscription && user.company.subscriptionStatus !== 'canceled') return next('/edit-subscription')
    else return next()
  }
}

const redirectOutOfEditSubscriptionPageIfNeeded = async (to, from, next) => {
  const user = store.getters.user
  if (to.path === '/edit-subscription') {
    if (user.data.role !== 'admin') return next('/dossiers')
    if (user.company.parentCompanyId && !user.data.isParentCompanyAdmin) return next('/dossiers')
    if (!user.company.hasOrHadSubscription || user.company.subscriptionStatus === 'canceled') return next('/subscribe')
    else return next()
  }
}

const checkIsLoggedIn = async (to, from, next) => {
  await waitForUserToBeLoaded()
  const user = store.getters.user
  if (user.data) {
    if (user.data.isConsultant) return next('/consultant')
    await waitForCompanyToBeLoaded()
  }
  if (user.loggedIn === null) {
    // wait for auth data to be loaded
    return setTimeout(() => checkIsLoggedIn(to, from, next), 100)
  } else if (user.loggedIn) {
    if (!user.data) return setTimeout(() => checkIsLoggedIn(to, from, next), 100)
    redirectToAnOnboardingStepIfNeeded(to, from, next)
    redirectOutOfCreateDossierIfNoDossiersLeft(to, from, next)
    redirectOutOfSubscribePageIfAlreadyHasOrHadSubscription(to, from, next)
    redirectOutOfEditSubscriptionPageIfNeeded(to, from, next)
  } else {
    return next('/login')
  }
}

const checkIsConsultantLoggedIn = async (to, from, next) => {
  await waitForUserToBeLoaded()
  const user = store.getters.user
  if (user.loggedIn === null) {
    // wait for auth data to be loaded
    return setTimeout(() => checkIsConsultantLoggedIn(to, from, next), 100)
  } else if (user.loggedIn) {
    if (!user.data) return setTimeout(() => checkIsConsultantLoggedIn(to, from, next), 100)
    if (user.data.isConsultant !== undefined && !user.data.isConsultant) return next('/dossiers')
    next()
  } else {
    if (to.params.invitationCode) return next(`/consultant?invitationCode=${to.params.invitationCode}`)
    else return next('/consultant')
  }
}

const checkIsConsultantNotLoggedIn = async (to, from, next) => {
  await waitForUserToBeLoaded()
  const user = store.getters.user
  if (user.loggedIn) {
    return next('/consultant/dossiers')
  } else {
    // Set Locale from query param ?lang=
    vuei18n.locale = to.query.lang
    return next()
  }
}

const checkIsAdmin = async (to, from, next) => {
  await waitForUserToBeLoaded()
  const user = store.getters.user
  if (user.loggedIn === null) {
    // wait for auth data to be loaded
    return setTimeout(() => checkIsAdmin(to, from, next), 100)
  } else if (user.loggedIn) {
    if (!user.data) return setTimeout(() => checkIsAdmin(to, from, next), 100)
    if (!user.data.isAdmin) return next('/dossiers')
    next()
  } else {
    return next('/')
  }
}


const checkIsParentCompanyAdmin = async (to, from, next) => {
  await waitForUserToBeLoaded()
  const user = store.getters.user
  if (user.loggedIn === null) {
    // wait for auth data to be loaded
    return setTimeout(() => checkIsParentCompanyAdmin(to, from, next), 100)
  } else if (user.loggedIn) {
    if (!user.data) return setTimeout(() => checkIsParentCompanyAdmin(to, from, next), 100)
    if (!user.data.isParentCompanyAdmin) return next('/dossiers')
    next()
  } else {
    return next('/')
  }
}

const routes = [
  {
    path: '/',
    component: Home,
    beforeEnter: checkIsNotLoggedIn,
  },
  {
    path: '/pricing',
    component: Pricing,
  },
  {
    path: '/book-demo',
    component: BookDemo,
    beforeEnter: checkIsNotLoggedIn,
  },
  {
    path: '/book-demo-success',
    component: BookDemoUploadDossierExamples,
    beforeEnter: checkIsNotLoggedIn,
  },
  {
    path: '/login',
    component: Login,
    beforeEnter: checkIsNotLoggedIn,
  },
  {
    path: '/signup',
    component: Signup,
    beforeEnter: checkIsNotLoggedIn,
  },
  {
    path: '/reset-password-send-email',
    component: ResetPasswordSendEmail,
    beforeEnter: checkIsNotLoggedIn,
  },
  {
    path: '/dossiers',
    component: ListDossiers,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/dossiers/create',
    component: CreateDossier,
    beforeEnter: checkIsLoggedIn,
  },

  {
    path: '/dossiers/:dossierId/edit',
    component: EditProfileAsUser,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/onboarding/personal-data',
    component: OnboardingPersonalData,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/onboarding/verify-email-address-send-email',
    component: OnboardingVerifyEmailAddressSendEmail,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/onboarding/verify-email-success',
    component: VerifyEmailAddressSuccess,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/onboarding/choose-company',
    component: OnboardingChooseCompany,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/account',
    component: Account,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/subscribe',
    component: Subscribe,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/subscribe-success',
    component: SubscribeSuccess,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/roadmap',
    component: Roadmap,
    beforeEnter: checkIsLoggedIn,
  },

  {
    path: '/edit-subscription',
    component: EditSubscription,
    beforeEnter: checkIsLoggedIn,
  },
  {
    path: '/consultant',
    component: ConsultantHome,
    beforeEnter: checkIsConsultantNotLoggedIn,
  },
  {
    path: '/consultant/login',
    component: ConsultantLogin,
    beforeEnter: checkIsConsultantNotLoggedIn,
  },
  {
    path: '/consultant/invitation-code/:invitationCode',
    component: ConsultantInvitationCode,
    beforeEnter: checkIsConsultantLoggedIn,
  },
  {
    path: '/consultant/dossiers',
    component: ConsultantListDossiers,
    beforeEnter: checkIsConsultantLoggedIn,
  },
  {
    path: '/consultant/dossiers/:dossierId/upload-cv',
    component: ConsultantUploadCv,
    beforeEnter: checkIsConsultantLoggedIn,
  },
  {
    path: '/consultant/dossiers/:dossierId/edit',
    component: EditProfileAsConsultant,
    beforeEnter: checkIsConsultantLoggedIn,
  },
  {
    path: '/from-token/edit-profile/:dossierId',
    component: EditProfileFromToken
  },
  {
    path: '/from-token/edit-profile-success',
    component: EditProfileFromTokenSuccess
  },
  {
    path: '/from-token/error',
    component: FromTokenError
  },
  {
    path: '/admin',
    component: Admin,
    beforeEnter: checkIsAdmin,
  },
  {
    path: '/parent-company-admin-dashboard',
    component: ParentCompanyAdminDashboard,
    beforeEnter: checkIsParentCompanyAdmin,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0)
  next();
})

export default router
